export const SELECT_ACCOUNT_ACTION = "SELECT_ACCOUNT_ACTION";

export const selectUnifiedAccount = (account) => ({
  type: SELECT_ACCOUNT_ACTION,
  payload: account,
});

